import { Injectable } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  toInteger(value: any): number {
    return parseInt(`${value}`, 10)
  }

  isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value))
  }

  padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2)
    } else {
      return ""
    }
  }
  static removePhoneMask(phone: string): string {
    return phone.replace(/\D/g, "")
  }
}
